import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonFilter'
})
export class JsonFilterPipe implements PipeTransform {

  transform(json: any[], args?: any[]): any[] {
    if(args == undefined){
      return json;
    }
    let searchText = args[0];
    let jsonKey = args[1];

    if(searchText == null || searchText == "undefined") return json;
    if(jsonKey == null || jsonKey == "undefined") return json;

    let returnObjects = json;
    json.forEach(filterObjectEntery => {
      if(filterObjectEntery.hasOwnProperty(jsonKey)){
        if(typeof filterObjectEntery[jsonKey] != "undefined" && filterObjectEntery[jsonKey] != null &&
        filterObjectEntery[jsonKey].toLowerCase().indexOf(searchText.toLowerCase()) > -1){
          //object value contains the user provided text
        }
         else {
          returnObjects = returnObjects.filter(obj => obj !== filterObjectEntery);
        }
      } else {
        console.log("search key is not available in JSON object");
      }
    });
    return returnObjects;
  }

}
